/* Feather Footwear — New Arrivals filters (style, size, price) */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  $$('[data-ff-new]').forEach(function (sec) {
    var cards = $$('[data-ff-card]', sec);
    var max = parseInt(sec.getAttribute('data-max'), 10) || 8;
    var empty = sec.querySelector('[data-new-empty]');
    var st = { type: 'all', size: 'any', under: Infinity };
    function mark(attr, val) {
      $$('[' + attr + ']', sec).forEach(function (b) {
        var on = b.getAttribute(attr) === String(val);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (st.type === 'all' || c.dataset.type === st.type) &&
          (st.size === 'any' || (c.dataset.sizes || '').indexOf(',' + st.size + ',') > -1) &&
          parseFloat(c.dataset.price) < st.under;
        if (ok && shown >= max) ok = false;
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      mark('data-new-type', st.type);
      mark('data-new-size', st.size);
      mark('data-new-under', st.under === Infinity ? 'any' : st.under);
    }
    $$('[data-new-type]', sec).forEach(function (b) { b.addEventListener('click', function () { st.type = b.getAttribute('data-new-type'); apply(); }); });
    $$('[data-new-size]', sec).forEach(function (b) { b.addEventListener('click', function () { st.size = b.getAttribute('data-new-size'); apply(); }); });
    $$('[data-new-under]', sec).forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-new-under'); st.under = v === 'any' ? Infinity : parseFloat(v); apply(); }); });
    var reset = sec.querySelector('[data-new-reset]');
    if (reset) reset.addEventListener('click', function () { st = { type: 'all', size: 'any', under: Infinity }; apply(); });
    apply();
  });

  /* Tall photos in quick view fill the frame, anchored to the bottom; square ones show whole */
  function tagTall(img) {
    if (img.naturalWidth) img.classList.toggle('is-tall', img.naturalHeight / img.naturalWidth > 1.15);
  }
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest('[data-qv-track],.ff-gallery')) tagTall(t);
  }, true);
  $$('[data-qv-track] img,.ff-gallery img').forEach(function (i) { if (i.complete) tagTall(i); });

  /* Homepage review cards rotate on their own; they pause while someone touches or hovers them */
  $$('.ff-quotes .ff-scroll').forEach(function (row) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var paused = false, resumeT = null;
    function pause() { paused = true; clearTimeout(resumeT); }
    function resume() { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, 4000); }
    row.addEventListener('pointerdown', pause);
    row.addEventListener('pointerup', resume);
    row.addEventListener('mouseenter', pause);
    row.addEventListener('mouseleave', resume);
    row.addEventListener('touchstart', pause, { passive: true });
    row.addEventListener('touchend', resume, { passive: true });
    setInterval(function () {
      if (paused || document.hidden || row.scrollWidth <= row.clientWidth + 4) return;
      var card = row.querySelector('.ff-quote');
      var step = card ? card.getBoundingClientRect().width + 10 : row.clientWidth * 0.8;
      if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 8) row.scrollTo({ left: 0, behavior: 'smooth' });
      else row.scrollBy({ left: step, behavior: 'smooth' });
    }, 3500);
  });
})();